module.exports = __webpack_public_path__ + "img/paci_ar_5.5d278938.png";